<template>
  <a-card title="多队列配置">
    <a-tabs v-if="!isMobileView" v-model:activeKey="formSearch.running_status" @change="() => {handleTableChange()}" >
      <a-tab-pane key="" tab="全部"></a-tab-pane>
      <a-tab-pane key="running" tab="✅ 运行中"></a-tab-pane>
      <a-tab-pane key="stopped" tab="🚫 已停止"></a-tab-pane>
    </a-tabs> 
    <a-form v-if="isMobileView" layout="inline" :model="formSearch" style="margin: 10px auto;" >
      <a-form-item label="Executor Name">
        <a-input placeholder="Executor Name" v-model:value="formSearch.executor_name" />
      </a-form-item>
      <a-form-item label="Topic" style="width: 340px;" >
        <a-select
          show-search
          :allowClear="true"
          v-model:value="formSearch.topic"
          @search="handleSearchTopics"
          :options="searchTopics"
          placeholder="Topic"
        />
      </a-form-item>
      <a-form-item>
        <a-input placeholder="自定义 Topic" v-model:value="formSearch.topic" />
      </a-form-item>
      <a-form-item>
        <a-button
          type="primary"
          html-type="submit"
          @click="() => {handleTableChange({current: 1, pageSize: pagination.pageSize})}"
          shape="circle"
        >
        <template #icon><SearchOutlined /></template>
        </a-button>
      </a-form-item>
    </a-form>
    
    <a-form v-else layout="inline" :model="formSearch" style="margin: 10px auto;" >
      <a-form-item label="Topic" style="width: 340px;" >
      <a-select
        show-search
        :allowClear="true"
        v-model:value="formSearch.topic"
        @search="handleSearchTopics"
        :options="searchTopics"
        placeholder="Topic"
      />
      </a-form-item>
      <a-form-item>
        <a-input placeholder="自定义 Topic" v-model:value="formSearch.topic" />
      </a-form-item>
      <a-form-item label="Executor Name">
        <a-input placeholder="Executor Name" v-model:value="formSearch.executor_name" />
      </a-form-item>


      <a-form-item  label="主机名" style="width: 300px;"  >
        <a-input :allowClear="true" placeholder="Host Name" v-model:value="formSearch.host_name" />
      </a-form-item>
      <a-form-item  label="GPU 端口">
        <a-input :allowClear="true" placeholder="GPU Port" v-model:value="formSearch.target_gpu_port" />
      </a-form-item>
       <a-form-item  label="HOST(IP)">
        <a-input :allowClear="true" placeholder="HOST" v-model:value="formSearch.target_host" />
      </a-form-item>

      <a-form-item label="Region" style="width: 300px;" >
       <a-select
        :allowClear="true"
        v-model:value="formSearch.region"
        :options="regins"
        placeholder="机房"
      />
      </a-form-item>
      <a-form-item>
        <a-button
          type="primary"
          html-type="submit"
          @click="() => {handleTableChange({current: 1, pageSize: pagination.pageSize})}"
          shape="circle"
        >
        <template #icon><SearchOutlined /></template>
        </a-button>
      </a-form-item>
      <a-form-item>
        <a-button
          type="primary"
          @click="handleCreate"
        >
        新建
        </a-button>
      </a-form-item>
    </a-form>

    <a-alert :message="noticeMessage" type="info" show-icon style="text-align: left;"  />
    <a-table 
      class="ant-table-striped"
      :row-key="record => record.id"
      :data-source="dataSource" 
      :columns="columns" 
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      >   
      <template #row_index="{ record }">
        <a-tag color="gray" >{{ record.row_index }}</a-tag>
      </template>
     
      <template #topic_name="{ record }">
        <a-button @click="() => { formSearch.topic = record.topic; handleTableChange({current: 1, pageSize: pagination.pageSize})}">{{ record.topic }}</a-button>
      </template>
      <template #host_name="{ record }">
        <a-button @click="() => { formSearch.host_name = record.host_name; handleTableChange({current: 1, pageSize: pagination.pageSize})}">{{ record.host_name }}</a-button>
      </template>
       <template #operator="{ record }">
        <a target="_blank" :href="`/home/user?user_id=${record.operator_id}`">{{Operators[record.operator_id] ? Operators[record.operator_id] : record.operator_id}}</a>
      </template>
      <template #running_status="{ record }">
        <a-tag v-if="record.running_status == 'running'" color="green">运行中</a-tag>
        <a-tag v-else color="gray">已暂停</a-tag>
      </template>
      <template #executor_name="{ record }">
        <a @click="openExecutorTasks(record)">
          <a-tag>{{ record.executor_name }}</a-tag>
        </a>
      </template>
      <template #action="{ record }">
       <a-space>
        <a-button :loading="record.loading_running" @click="handleModifyStatus(record, 'stopped')" v-if="record.running_status == 'running'"  danger type="primary" >
          暂停 {{ record.action_run ? '👍🏻' : '' }}
        </a-button>
        <a-button :loading="record.loading_running" @click="handleModifyStatus(record, 'running')"  v-if="record.running_status == 'stopped'" type="primary">
          <template v-if="record.comfirm_running">
            确定运行吗？
          </template>
            <template v-else>
              运行 {{ record.action_run ? '👍🏻' : '' }}
          </template>
        </a-button>
        
        <a-button  warn @click="handleUpdate(record)"  >编辑</a-button>
        <a-button :loading="record.loading_restaring" @click="handleRestart(record)" danger >
          <template v-if="record.comfirm_restarting">
            确定重启吗？
          </template>
          <template v-else>
            重启  {{ record.action_restart ? '👍🏻' : '' }}
          </template>
        </a-button>

        <a-popconfirm
          title="确定删除吗?"
          ok-text="确定"
          cancel-text="不了"
          @confirm="handleDelete(record)"
        >
          <a-button  :loading="record.loading" v-if="record.running_status == 'stopped'"  danger   >删除</a-button>
        </a-popconfirm>
       </a-space>
      </template>
      </a-table>
  </a-card>
  <a-modal v-model:visible="openDia" :title="formRecord.id == '' ? '新建' : '编辑'" @cancel="resetForm" @ok="handleConfirm" :confirm-loading="loading">
    <a-form :label-col="{ span: 8 }" :model="formRecord" :disabled="formRecord.running_status != 'stopped'"  style="margin: 10px auto;" :rules="rules" ref="formRef" >
        <a-form-item required label="Topic" name="topic">
          <a-select
            show-search
            :allowClear="true"
            @search="handleSearchTopics"
            v-model:value="formRecord.topic"
            :options="topicSelection"
            placeholder="Topic"
          />
        </a-form-item>
        <a-form-item label="自定义 Topic" name="topic">
          <a-input placeholder="自定义 Topic" v-model:value="formRecord.topic" />
        </a-form-item>
        <a-form-item required label="Host Name" name="host_name">
          <a-input placeholder="host name" v-model:value="formRecord.host_name" />
        </a-form-item>
        <a-form-item required label="Host" name="target_host">
          <a-input placeholder="target_host" v-model:value="formRecord.target_host" />
        </a-form-item>
        <a-form-item required label="GPU Port" name="target_gpu_port">
          <a-input placeholder="target_gpu_port" v-model:value="formRecord.target_gpu_port" />
        </a-form-item>
        <a-form-item label="API 版本" name="version">
          <a-input placeholder="version" v-model:value="formRecord.version" />
        </a-form-item>
        <a-form-item required label="机房"  name="region">
          <a-select
            v-model:value="formRecord.region"
            :options="regins"
            placeholder="region"
          />
        </a-form-item>
        <a-form-item required label="运行状态" name="running_status">
          <a-select
            v-model:value="formRecord.running_status"
            :options="[
               {
                  label: '运行中',
                  value: 'running'
                },
                {
                  label: '已暂停',
                  value: 'stopped'
                },
            ]"
            placeholder="running_status"
          />
        </a-form-item>
        <a-form-item label="备注" name="remark">
          <a-input placeholder="备注" v-model:value="formRecord.remark" />
        </a-form-item>
        
      </a-form>
      <div style="text-align: right;" >
        <a-button v-if="formRecord.id != ''" @click="() => { handleCopy() }" danger >以当前参数创建</a-button>
      </div>

  </a-modal>
  <!-- <UserEditor v-model:visible="userEditorVisible" @cancle="userEditorVisible=false" /> -->

</template>
<script>
import { defineComponent } from 'vue'
// import UserEditor from '@/components/UserEditor.vue'
import { SearchOutlined } from '@ant-design/icons-vue';
import request from '@/utils/request'
import {useRoute} from 'vue-router'

import { Operators, ExecutorTopics } from '@/utils/macro'

const DefaultRecord = {
  id: "",
  topic:'',
  host_name: '',
  running_status: 'stopped',
  target_host: '',
  target_gpu_port: '',
  region: 'king',
  version: 'v1',
  remark: '',
  source: '',
  is_sub_queue: 1,
}


var regins = [{
            value: 'king',
            label: '金山云'
          },{
            value: 'king.xm',
            label: '金山云-厦门'
          },{
            value: 'king.jn',
            label: '金山云-济南'
          },{
            value: 'king.zj',
            label: '金山云-镇江'
          },{
            value: 'king.cz',
            label: '金山云-常州'
          },{
            value: 'aliyun',
            label: '阿里云'
          }, {
            value: 'aliyun.sh',
            label: '阿里云-上海'
          }, {
            value: 'aliyun.pek',
            label: '阿里云-北京'
          },{
            value: 'autodl',
            label: 'AutoDL'
          }]
var topicSelection = []
for (var i = 0; i < ExecutorTopics.length; i++) {
  topicSelection.push({
    value: ExecutorTopics[i].topic,
    label: ExecutorTopics[i].name + "(" + ExecutorTopics[i].topic + ")",
  })
}


export default defineComponent({
  components: {
    SearchOutlined
  },
  data(){
    return {
      regins: regins,
      Operators,
      styleNames :{},
      loading: false,
      openDia: false,
      dataSource: [],
      action_image_index: 0,
      formRecord: {
        ...DefaultRecord
      },
      rules:{
        topic: [
          { required: true, message: 'required', trigger: 'change' },
        ],
      },
      pagination: {
        total: 1,
        current: 1,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '',
      topicSelection,
      searchTopics: [].concat(topicSelection),
      runningStatus: [
      {
          label: '全部',
          value: ''
        },
        {
          label: '运行中',
          value: 'running'
        },
        {
          label: '已停止',
          value: 'stopped'
        },
      ],
       formSearch: {
        topic:'',
        host_name: '',
        executor_name: '',
        running_status: '',
        target_host: '',
        target_gpu_port: '',
        region: '',
        is_sub_queue: 1,
      },
    }
  },
  computed: {
    isMobileView: () => {
      return window.innerWidth < 768
    },
  },
  mounted(){
    this.searchTopics = [].concat(topicSelection)
    const route = useRoute()
    this.formSearch.topic = route.query['topic']
    this.formSearch.host_name = route.query['host_name']
    this.formSearch.executor_name = route.query['executor_name']
    this.handleTableChange()
  },
  methods: {
    handleSearchTopics(val){
      console.log('val', val)
      this.searchTopics = []
      for (let v of topicSelection) {
        console.log(v)
        if(v.label.indexOf(val) > -1) {
          this.searchTopics.push({
            ...v
          })
        }
      }
      console.log("this.searchTopics", this.searchTopics)
    },
    openExecutorTasks(record){
      window.open('/home/creation/works?queue_name='+record.executor_name)
    },
    async handleCopy(){
      this.loading = true
      const payload = {
        ...this.formRecord,
        running_status: 'stopped',
        is_sub_queue: 1,
      }
      try {
        await request.post('/api/xae/executors', payload)
        this.openDia = !this.openDia
        this.handleTableChange()
      } finally {
        this.loading = false
      }
    },
    async handleConfirm(){
      this.loading = true
      if (!this.formRecord.target_gpu_port) {
        this.$message.error('请输入 GPU Port')
        this.loading = false
        return
      }
      const payload = {
        ...this.formRecord,
        is_sub_queue: 1,
      }
      try {
        if (this.formRecord.id) {
          await request.put(`/api/xae/executors/${this.formRecord.id}`, payload)
        } else {
          await request.post('/api/xae/executors', payload)
        }
        this.openDia = !this.openDia
        this.handleTableChange()
      } finally {
        this.loading = false
      }
    },
    handleCreate(){
      this.openDia = true
      let data = {
        ...DefaultRecord
      }
      this.formRecord = data
    },
    handleUpdate(record){
      this.openDia = true
      let data = {
        ...record,
        is_sub_queue: 1,
      }
      this.formRecord = data
    },
    handleRestart(record){
      if (!record.comfirm_restarting) {
        record.comfirm_restarting = true
        setTimeout(() => {
          record.comfirm_restarting = false
        }, 3000)
        return
      }
      record.loading_restaring = true
      request.post(`/api/xae/executors/${record.id}/restart`, { }).then(() => {
        this.$message.success('重启成功')
      }).catch(() => {
        this.$message.error('重启失败')
      }).finally(() => {
        record.loading_restaring = false
        record.action_restart=true
        record.comfirm_restarting = false
        // this.handleTableChange()
      })
      
    },
    async handleDelete(record){
      this.loading = true
      await request.delete(`/api/xae/executors/${record.id}`, { })
      this.handleTableChange()
    },
    async handleModifyStatus(record, status){
      if (status == "running" && !record.comfirm_running) {
        record.comfirm_running = true
        setTimeout(() => {
          record.comfirm_running = false
        }, 3000)
        return
      }
      record.loading_running = true
      record.action_run=true
      await request.put(`/api/xae/executors/${record.id}/running_status`, {
        running_status: status,
      })
      record.running_status = status
      record.loading_running = false
      record.comfirm_running = false
      // this.handleTableChange()
    },
    resetForm() {
      this.$refs.formRef.resetFields();
    },
    async handleTableChange (pagi) {
      if (!pagi) {
        pagi = this.pagination
      }
      this.loading = true
      let target_host = ""
      if (this.formSearch.target_host) {
        target_host = this.formSearch.target_host
        if (this.formSearch.target_host.indexOf("http") == -1){
          target_host = "http://" + this.formSearch.target_host + "/api/"
        }
      }
      const rsp = await request.get('/api/xae/executors', {
        offset: (pagi.current - 1) * pagi.pageSize ,
        limit: pagi.pageSize,
        ...this.formSearch,
        target_host: target_host,
        is_sub_queue: 1,
      })
      this.loading = false
      if (!rsp.data.list) {
        rsp.data.list = []
      }
     
      for (let i = 0; i < rsp.data.list.length; i++) {
        rsp.data.list[i].loading = false
        rsp.data.list[i].loading_running = false
        rsp.data.list[i].loading_restaring = false
        rsp.data.list[i].comfirm_running = false
        rsp.data.list[i].comfirm_restarting = false
        rsp.data.list[i].action_run = false
        rsp.data.list[i].action_restart = false
        rsp.data.list[i].created_at = new Date(rsp.data.list[i].created_at).toLocaleString()
        rsp.data.list[i].updated_at = new Date(rsp.data.list[i].updated_at).toLocaleString()
      }
    
      this.dataSource = [].concat(rsp.data.list)
      if (this.formSearch.host_name) {
        // 将 dataSource 按照 item.port 从小到大排序
        this.dataSource.sort((a, b) => {
          return a.target_gpu_port - b.target_gpu_port
        })
      }
     
      let rowIndex = 0
      for(let i = 0; i < this.dataSource.length; i++) {
        this.dataSource[i].row_index = rowIndex++
      }
      this.noticeMessage = `共 ${rsp.data.pagination.total} 条`
      this.pagination.total = rsp.data.pagination.total
      this.pagination.current = pagi.current
      this.pagination.pageSize = pagi.pageSize
    },
  },
  setup() {
   
    return {
      uploadInput: null,
      columns: [
      {
          title: 'row',
          dataIndex: 'row_index',
          key: 'row_index',
          slots: { customRender: 'row_index' },
          hidden: true,
        },
      {
          title: 'id',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: 'Topic',
          dataIndex: 'topic',
          key: 'topic',
          slots: { customRender: 'topic_name' },
        },
        {
          title: 'Host Name',
          dataIndex: 'host_name',
          key: 'host_name',
          slots: { customRender: 'host_name' },
        },
        {
          title: 'Executor Name',
          slots: { customRender: 'executor_name' },
        },
        {
          title: 'Host',
          dataIndex: 'target_host',
          key: 'target_host',
        },
        {
          title: '备注',
          dataIndex: 'remark',
          key: 'remark',
        },
        // {
        //   title: 'GPU Port',
        //   dataIndex: 'target_gpu_port',
        //   key: 'target_gpu_port',
        // },
        // {
        //   title: 'Version',
        //   dataIndex: 'version',
        //   key: 'version',
        // },
      
        {
          title: '运行状态',
          dataIndex: 'running_status',
          key: 'running_status',
          slots: { customRender: 'running_status' },
        },
        // {
        //   title: '运行次数',
        //   dataIndex: 'executed_count',
        //   key: 'executed_count',
        // },
        // {
        //   title: '机房',
        //   dataIndex: 'region',
        //   key: 'region',
        // },
        {
          title: '操作人',
          dataIndex: 'operator',
          key: 'operator',
          slots: { customRender: 'operator' },
        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          key: 'created_at',
        },
        {
          title: '修改时间',
          dataIndex: 'updated_at',
          key: 'updated_at',
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
       
      ],
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}
</style>
